import { deprecatedFacets } from '../global-constants';

export const removeDeprecatedFacets = (facetArray = []) =>
	facetArray.filter(({ id }) => !deprecatedFacets.includes(id));
